import { CardConsentsComponent } from '../../components/card-consents/card-consents.component';
import { ListTabsComponent } from '../../components/list-tabs/list-tabs.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RoutingService from '../../services/routing.service';
import { PanelDirective } from '../../directives/panel.directive';

@Component({
	standalone: true,
	selector: 'consents',
	templateUrl: './consents.component.html',
	imports: [ CommonModule, PanelDirective, CardConsentsComponent, ListTabsComponent, FormsModule ]
})
export default class ConsentView implements OnInit {
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('consents').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.activeTab = 0;
		this.vm.tabs = [{
			label: this.angularFilterHelperService.translate('Consents.Title.My_Consents'),
			type: 'bookings'
		}];
		// MIN-271 removed:
		//{
		//	label: this.angularFilterHelperService.translate('Consents.Title.General_Consents'),
		//	type: 'general'
		//}
	}
	
}